import { Theme, Typography } from '@mui/material';
import { CustomContentProps, SnackbarContent, useSnackbar } from 'notistack';
import { forwardRef } from 'react';

import { HBToastStyled } from './HBToast.styles';

export interface HBToastProps extends CustomContentProps {
  variant: 'error' | 'success' | 'warning';
}

export const HBToast = forwardRef<HTMLDivElement, HBToastProps>((props, ref) => {
  const { closeSnackbar } = useSnackbar();
  const Icon = props.iconVariant[props.variant];

  return (
    <HBToastStyled variant={props.variant} onClick={() => closeSnackbar(props.id)}>
      <SnackbarContent ref={ref} className={`hb-snackbar variant-${props.variant}`}>
        {Icon}
        <Typography
          variant="body2"
          sx={(theme: Theme) => ({
            fontWeight: theme.typography.fontWeightMedium,
            color: 'white',
          })}
        >
          {props.message}
        </Typography>
      </SnackbarContent>
    </HBToastStyled>
  );
});

HBToast.displayName = 'HBToast';
